import IntlProvider from './IntlProvider';

export default IntlProvider;
